module.exports = __webpack_public_path__ + "static/img/3491_phase_function_Paper_PointsHejduk_Prediction.dc7d0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3491_phase_function_Paper_PointsHejduk_Prediction.png
// module id = PJLU
// module chunks = 0